import apiClient from '@/shared/api/client'
import type { Department } from '@/shared/types/master'

interface ListParams {
  page?: number
  page_size?: number
  plant_id?: string
  department_type?: string
  is_active?: boolean
}

interface PaginatedResponse<T> {
  items: T[]
  total: number
  page: number
  page_size: number
}

export const departmentsApi = {
  list: async (params?: ListParams): Promise<PaginatedResponse<Department>> => {
    const res = await apiClient.get<PaginatedResponse<Department>>('/masters/departments', { params })
    return res.data
  },

  get: async (id: string): Promise<Department> => {
    const res = await apiClient.get<Department>(`/masters/departments/${id}`)
    return res.data
  },

  create: async (data: Omit<Department, 'id' | 'plant_name'>): Promise<Department> => {
    const res = await apiClient.post<Department>('/masters/departments', data)
    return res.data
  },

  update: async (id: string, data: Partial<Department>): Promise<Department> => {
    const res = await apiClient.patch<Department>(`/masters/departments/${id}`, data)
    return res.data
  },
}
